module.exports = __webpack_public_path__ + "img/jessica-ava.13e4807.png";